import { forwardRef, useEffect, useState } from 'react'
import { Pie } from '.'
import { colorFromValue, practices } from '../../../lookups'
import './PracticePie.scss'

export const PracticePie = forwardRef(function PracticePie({
  values, selectedPractice, onPracticeSelected, size = '100%', hoverEffect = true,
  headings = true, showAllHeadings, highlightSelection = true, transition, ...props
}, ref) {
  const [angle, setAngle] = useState(0)

  useEffect(() => {
    if(typeof selectedPractice === 'number') {
      setAngle(current => {
        const rotations = [
          -30 - (selectedPractice - 6) * 60,
          -30 - selectedPractice * 60,
          -30 - (selectedPractice + 6) * 60
        ]
        const min = Math.min(...rotations.map(x => Math.abs(current - x)))
        return rotations.find(x => Math.abs(current - x) === min)
      })
    }
  }, [selectedPractice])

  return (
    <Pie
      size={size}
      values={values}
      colors={values.map(x => [x].flat().map(colorFromValue))}
      headings={practices.map(x => x.name.toUpperCase())}
      headingOpacity={headings ? 1 : 0}
      showAllHeadings={showAllHeadings}
      selectedSlice={highlightSelection ? selectedPractice : undefined}
      onSliceClick={onPracticeSelected}
      rotate={angle}
      ref={ref}
      transition={transition}
      className={(hoverEffect && selectedPractice === undefined) ? 'highlight-slice' : undefined}
      {...props}
    />
  )
})
